module.exports = __webpack_public_path__ + "static/img/s7.fbf0b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s7.png
// module id = KZ/U
// module chunks = 1